import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";
const {
  colors: { ui },
} = constants;
const fontSize = typographyStyles.fontSize;
const fontFamily = typographyStyles.fontFamily;

export const checkBoxListCss: CSSObject = {
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  borderRadius: 8,
  paddingLeft: "16px",
  marginTop: 0,
  marginBottom: 0,
  listStyleType: "disc",
};

export const listItemCss: CSSObject = {
  background: "white",
};

export const todoCss: CSSObject = {
  ...fontSize.textM,
  ...fontFamily.circular,
  fontWeight: 700,
  marginBottom: "10px",
};

export const optionTextCss: CSSObject = {
  ...fontSize.textM,
  ...fontFamily.circular,
  fontWeight: 400,
  color: ui.neutral[500],
};
